module.exports = __webpack_public_path__ + "media/images/ae-logo-color-7f5e3ac67b1f60f04cfcfe08d4ae6a5f.svg";